
export const accounts = {
  'accounts.title': 'Investmentkonten',
  'accounts.subtitle': 'Anzeigen und Verwalten Ihrer Investmentkonten',
  'accounts.loading': 'Konten werden geladen...',
  'accounts.error': 'Fehler beim Laden der Konten',
  'accounts.noAccounts': 'Keine Investmentkonten gefunden',
  'accounts.accountNumber': 'Kontonummer',
  'accounts.balance': 'Saldo',
  'accounts.accountShare': 'Kontoanteil',
  'accounts.accountOpen': 'Konto eröffnet',
  'accounts.broker': 'Broker',
  'accounts.active': 'Aktiv',
  'accounts.inactive': 'Inaktiv',
  'accounts.pending': 'Ausstehend',
  'accounts.closed': 'Geschlossen',
  
  // Transactions section
  'accounts.transactions.title': 'Kontotransaktionen',
  'accounts.transactions.subtitle': 'Anzeigen Ihrer Ein- und Auszahlungshistorie',
  'accounts.transactions.loading': 'Transaktionen werden geladen...',
  'accounts.transactions.error': 'Fehler beim Laden der Transaktionen',
  'accounts.transactions.noTransactions': 'Keine Transaktionen gefunden',
  'accounts.transactions.export': 'CSV exportieren',
  'accounts.transactions.loadMore': 'Mehr laden',
  
  // Table columns
  'accounts.transactions.table.account': 'Konto',
  'accounts.transactions.table.date': 'Datum',
  'accounts.transactions.table.amount': 'Betrag',
  'accounts.transactions.table.operation': 'Vorgang',
  
  // Operations
  'accounts.transactions.deposit': 'Einzahlung',
  'accounts.transactions.withdrawal': 'Auszahlung',
  
  // Filters
  'accounts.transactions.filters.account': 'Nach Konto filtern',
  'accounts.transactions.filters.operation': 'Nach Vorgang filtern',
  'accounts.transactions.filters.dateFrom': 'Von Datum',
  'accounts.transactions.filters.dateTo': 'Bis Datum',
  'accounts.transactions.filters.apply': 'Filter anwenden',
  'accounts.transactions.filters.reset': 'Filter zurücksetzen',
  'accounts.transactions.filters.allAccounts': 'Alle Konten',
  'accounts.transactions.filters.allOperations': 'Alle Vorgänge',
  
  // Add Account section
  'accounts.addAccount.title': 'PAMM Investmentkonto hinzufügen',
  'accounts.addAccount.subtitle': 'PAMM-Konto-ID und zugehörige E-Mail angeben',
  'accounts.addAccount.pammAccount': 'PAMM-Konto',
  'accounts.addAccount.associatedEmail': 'Zugehörige E-Mail',
  'accounts.addAccount.validateAccount': 'Konto validieren',
  'accounts.addAccount.instructionsTitle': 'Befolgen Sie die nachstehenden Anweisungen, um Ihr PAMM-Konto zu finden',
  'accounts.addAccount.step1.title': 'Anmeldung bei Ihrem PAMM-Konto mit den per E-Mail erhaltenen Zugangsdaten',
  'accounts.addAccount.step1.substep1': 'Suchen Sie nach einer E-Mail mit dem Betreff: "RADEX MARKETS - Successfully joined PAMM of the money manager - The Club Funding Pro"',
  'accounts.addAccount.step1.substep2': 'Öffnen Sie den in der E-Mail bereitgestellten Link: https://pamm.radexmarkets.com/app/auth/investor',
  'accounts.addAccount.step2.title': 'Ermitteln Sie Ihre PAMM-Konto-ID über das Radex Markets Portal, bei dem Sie sich gerade angemeldet haben',
  'accounts.addAccount.step2.description': 'Die PAMM-Konto-ID ist im folgenden Bild hervorgehoben',
  'accounts.addAccount.validation.pammAccountRequired': 'PAMM-Konto ist erforderlich',
  'accounts.addAccount.validation.pammAccountInvalid': 'PAMM-Konto muss eine positive Zahl sein',
  'accounts.addAccount.validation.emailRequired': 'Zugehörige E-Mail ist erforderlich',
  'accounts.addAccount.validation.emailInvalid': 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
  'accounts.addAccount.success': 'Konto erfolgreich validiert',
  'accounts.addAccount.error': 'Fehler bei der Kontovalidierung',
  'accounts.addAccount.validating': 'Konto wird validiert...',
  'accounts.addAccount.successDescription': 'Ihr Investmentkonto wurde erfolgreich hinzugefügt.',
  
  // Error messages
  'accounts.addAccount.messages.success': 'Konto erfolgreich validiert und hinzugefügt',
  'accounts.addAccount.messages.missing_fields': 'Bitte füllen Sie alle erforderlichen Felder aus',
  'accounts.addAccount.messages.account_exists': 'Dieses Investmentkonto ist bereits registriert',
  'accounts.addAccount.messages.account_already_registered': 'Dieses Konto kann nicht registriert werden',
  'accounts.addAccount.messages.account_not_active': 'Das Konto ist nicht aktiv. Bitte stellen Sie sicher, dass Ihr Konto vor der Validierung aktiv ist',
  'accounts.addAccount.messages.account_validation_failed': 'Kontovalidierung fehlgeschlagen. Bitte überprüfen Sie Ihre Kontonummer und E-Mail-Adresse',
  'accounts.addAccount.messages.insert_failed': 'Fehler beim Registrieren des Kontos. Bitte versuchen Sie es erneut',
  'accounts.addAccount.messages.server_error': 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut',
  'accounts.addAccount.messages.systemError': 'Der Vorgang ist fehlgeschlagen, versuchen Sie es später erneut oder wenden Sie sich an den Kundensupport',
  
  // Placeholders
  'accounts.addAccount.placeholders.pammAccount': 'PAMM-Konto-ID eingeben',
  'accounts.addAccount.placeholders.associatedEmail': 'Zugehörige E-Mail eingeben',
  
  // General
  'accounts.notAvailable': 'Nicht verfügbar',
  'accounts.addNewAccount': 'Neues Konto Hinzufügen',
};
